import React from "react";
import { Card } from "semantic-ui-react";
import RedTag from "../../../components/Products/components/RedTag/RedTag";
const DesktopImgs = (props) => {
  const { selectorImage, setSelectorImage, productDetail } = props;
  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
      <div className="col-lg-3 col-md-2 col-sm-1 justify-content-center grid-images">
        <Card.Group itemsPerRow={1}>
          {productDetail.data &&
            productDetail.data.images.map((productImage, index) => (
              <Card
                color={selectorImage === index ? "red" : "grey"}
                image={JSON.parse(productImage).url}
                key={index}
                onClick={() => setSelectorImage(index)}
                style={{
                  backgroundColor: "gray",
                  display: "flex",
                  backgroundSize: "cover",
                  justifyContent: "flex-end",
                }}
              />
            ))}
        </Card.Group>
      </div>
      <div style={{ width: "100%" }}>
        <Card
          className="card-selected"
          style={{
            backgroundImage: `url(${
              productDetail.data && productDetail.data.images.length > 0
                ? JSON.parse(productDetail.data.images[selectorImage]).url
                : null
            })`,
            display: "flex",
            backgroundSize: "cover",
            objectFit: "cover",
            backgroundPosition: "center",
            height: 700,
            width: "100%",
          }}
        >
          {productDetail.data && !productDetail.data.available ? (
            <RedTag message="Agotado" />
          ) : null}
        </Card>
      </div>
    </div>
  );
};

export default DesktopImgs;
